import { Link } from "react-router-dom";
import { COMPANY } from "../data/company";
import SEO from "../components/SEO";

export default function Forbidden() {
  return (
    <>
      <SEO
        title="Adgang nægtet (403)"
        description={`Adgang nægtet hos ${COMPANY.name}. Gå til forsiden eller kontakt os.`}
        path="/403"
      />

      <section className="py-24 sm:py-32 bg-[#FAFAF8] min-h-[60vh] flex items-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 rounded-full bg-[#111111] text-[#A78E51] border border-[#A78E51]/40 flex items-center justify-center mx-auto mb-6 text-3xl font-extrabold shadow-sm">
            403
          </div>

          <span className="text-[#A78E51] font-bold text-xs uppercase tracking-widest block mb-2">
            Adgang forbudt (403)
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#111111] tracking-tight">
            Du har ikke adgang til denne side
          </h1>
          <p className="mt-4 text-neutral-600 text-sm sm:text-base max-w-lg mx-auto leading-relaxed">
            Du har ikke de nødvendige rettigheder til at få vist denne ressource. Hvis du mener dette er en fejl, er du velkommen til at kontakte os.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-[#111111] text-white font-bold text-sm hover:bg-neutral-800 transition-colors shadow-sm"
            >
              <i className="fa-solid fa-house text-[#A78E51] text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-white border border-neutral-300 text-[#111111] hover:border-[#A78E51] font-bold text-sm transition-colors shadow-sm"
            >
              <i className="fa-solid fa-envelope text-[#A78E51] text-xs" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
